import React, {useState} from 'react';
import Link from 'next/link';
import Button from 'react-bootstrap/Button';
import styles from '../styles/header/Drawer.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight, faCoins } from '@fortawesome/free-solid-svg-icons';

const MobileSubmenu = (props) => {
    const {submenu, closeMenu} = props;
    const [isOpen, editIsOpen]  = useState(false);
    
    const toggleMenu = () => {editIsOpen(!isOpen)}

    const submenuList = 
            <div>
                <ul className={`${styles.list} ${isOpen ? '' : 'd-none'}`}>
                    {submenu.options.map( (item, i) =>
                        <li key={i}>
                            <Button as={Link} href={item.link} variant="link" onClick={closeMenu}>
                                    {item.name}
                                </Button>
                        </li>
                    )}
                </ul>
                <hr className={styles.divider} />
            </div>;
    

    return (
            <li>
                <Button className="btn btn-secondary" onClick={toggleMenu}>
                    <span>
                        <FontAwesomeIcon icon={submenu.icon} className="me-3" height="16" width="16" />
                        {submenu.menuItem.title}
                    </span>
                    <FontAwesomeIcon icon={isOpen ? faChevronDown : faChevronRight} className="inline-block float-end" height="16" width="16" />
                </Button>
                {submenuList}
            </li>     
    );
}

export default MobileSubmenu;